/**
 * ModernLayout - New Layout Component
 * 
 * This layout provides a clean, minimal enterprise-style UI with:
 * - Left sidebar navigation
 * - Main content area
 * - Isolated theme system (CSS variables scoped to .modern-layout-wrapper)
 * 
 * Theme Isolation:
 * - Uses CSS variables scoped to .modern-layout-wrapper class
 * - Does NOT interfere with existing legacy theme
 * - All styles are prefixed with --modern- to avoid conflicts
 * 
 * Migration Strategy:
 * - Opt-in by setting layout: ModernLayout in routes.js
 * - Existing routes continue using HomeLayout (legacy)
 * - Components can be gradually migrated by changing their route's layout prop
 * - No changes needed to existing components - they work in both layouts
 */

import React from 'react';
import { object, oneOfType, objectOf, string, symbol, func } from 'prop-types';
import ModernSidebar from './ModernSidebar';
import './ModernLayout.css';

const ModernLayout = (props) => {
  const { children } = props;

  return (
    <div className="modern-layout-wrapper">
      <div className="modern-layout-container">
        <ModernSidebar />
        <main className="modern-layout-content">
          {children}
        </main>
      </div>
    </div>
  );
};

ModernLayout.propTypes = {
  children: objectOf(oneOfType([object, string, symbol, func])),
};

ModernLayout.defaultProps = {
  children: {},
};

export default ModernLayout;
